import * as React from 'react';
import type { SVGProps } from 'react';
const Svg256BitTlsEncryption = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M29 56h-3a4 4 0 0 1-4-4V24a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4h-3m-11-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0 0h.043l-6.386 6.385-5.656-5.657 6.038-6.038M40 54l6.386 6.385 5.656-5.657-6.038-6.038M34 28h12m-16 7h20"
    />
  </svg>
);
export default Svg256BitTlsEncryption;
